module.exports = __webpack_public_path__ + "img/banner.73835142.svg";